module.exports = __webpack_public_path__ + "static/media/May_2026_4.1a747cba.webp";